export default "__VITE_ASSET__MG9FW0oi__"